// i18n area 'apps' — locale fi-FI (task #171, onda 2): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/apps.fi-FI.meta.json.
import type { enUS } from './apps'

export const fiFI: typeof enUS = {
  apps: {
    title: 'App',
    create: 'Luo sovellus',
    createTitle: 'Luo sovellus',
    editTitle: 'Muokkaa sovellusta',
    name: 'Nimi',
    nameHint: 'DNS-1123, yksilöllinen scopessa — luonnin jälkeen muuttumaton.',
    node: 'Solmu',
    nodeHint: 'Jäsensolmu, joka palvelee sitä — eksplisiittinen placement (scheduler tulee myöhemmin).',
    image: 'Image',
    editImageHint: 'Uusi viittaus ratkaistaan uudelleen kirjanpidon kautta — pin/rollback-ele.',
    imagePolicy: 'Policy',
    policyPinned: 'pinned',
    policyTracking: 'tracking',
    policyPinnedHint: 'Digest liikkuu vain komennosta.',
    policyTrackingHint: 'Automaattinen rolling, kun refresh siirtää branchia.',
    archMovePolicy: 'Cross-arch-siirto',
    archMoveRefuse: 'refuse',
    archMoveReresolve: 'reresolve',
    archMovePolicyHint: 'Mitä tapahtuu, jos app siirretään toisen arkkitehtuurin nodeen: refuse hylkää siirron, reresolve ratkaisee lockfilen uudelleen branchista uudella archilla — sisältö muuttuu, ja vastaus nimeää digestin muutoksen.',
    network: 'Verkko',
    networkHint: 'Untagged L3-liitos: looginen fabric-verkko (suositeltu — gateway/DNS sen ainoasta lähteestä), overlay tai paljas host-bridge (ei suositella).',
    overlayPrefix: 'overlay:',
    fabricPrefix: 'fabric:',
    bridgePrefix: 'host-bridge:',
    ipAssignment: 'IP:n jako',
    ipStatic: 'Staattinen',
    ipAuto: 'Automaattinen (IPAM)',
    ipAssignmentHint_static: 'Sinä annat osoitteen, nyt.',
    ipAssignmentHint_auto: 'IPAM valitsee vapaan osoitteen verkon TVirtille varatuista rangeista.',
    bridgeDiscouraged: 'Paljas host-bridge — EI SUOSITELLA: TVirt ei tiedä mitään sen osoitteistuksesta, joten gateway ja DNS on annettava käsin. Suositeltu tie on looginen fabric-verkko.',
    ip: 'IP',
    ipHint: 'Staattinen IPv4 liitoksen aliverkon sisällä.',
    ipCidrHint: 'CIDR-muodossa paljaalla bridgellä (esim. 192.168.1.10/24) — prefiksiä ei ole mistä johtaa.',
    gateway: 'Gateway',
    gatewayManualHint: 'Manuaalinen — paljas bridge ei johda mitään.',
    dnsServers: 'DNS-palvelimet',
    dnsManualHint: 'Manuaaliset, pilkulla eroteltuina — vähintään yksi.',
    rootKind: 'Root',
    rootEphemeral: 'efemeerinen',
    rootPersistent: 'pysyvä',
    rootEphemeralHint: 'Luodaan imagesta uudelleen joka uudelleenluonnissa; elää klusterin efemeerisellä storagella.',
    rootEphemeralHintNamed: 'Luodaan imagesta uudelleen joka uudelleenluonnissa; elää klusterin efemeerisellä storagella ({name}).',
    rootPersistentHint: 'Selviää uudelleenkäynnistyksistä; elää valitsemallasi storagella.',
    rootStorage: 'Root-storage',
    editRootStorageHint: 'Root renderöidään uudelleen uudelle poolille — olemassa oleva data EI siirry itsestään.',
    volumes: 'Volyymit',
    volumeAdd: 'Lisää volyymi',
    volumeName: 'Nimi',
    volumeMountPath: 'Mount-polku',
    volumeKind: 'Tyyppi',
    volumeStorage: 'Storage',
    devices: 'Laitteet',
    deviceClassHint: 'Pyydetään LUOKKAA (gpu-device- tai usb-device-tunniste), ei koskaan tiettyä laitetta: ilmoitetulla solmulla on oltava Appeille merkitty laite. Useat Appit voivat käyttää samaa laitetta — kontti jakaa sen, se ei ota sitä isännältä pois.',
    deviceSlot: 'Paikka',
    deviceTag: 'Tunniste',
    deviceValue: 'Luokka',
    deviceUnresolved: 'juuri nyt ei ratkea mitään',
    noDeviceTags: 'Ei vielä yhtään gpu-device- tai usb-device-tunnistetta: luo sellainen ja liitä se Appeille merkittyihin laitteisiin.',
    env: 'Ympäristö',
    envHint: 'Yksi AVAIN=arvo per rivi.',
    secretEnvTitle: 'Salaiset muuttujat',
    secretEnvNotice: 'Salainen arvo ei palaa enää koskaan API:sta: kukaan ei lue sitä uudelleen, ei edes se, joka sen kirjoitti. Checkpointissa se kulkee masterpassilla sinetöitynä, joten palautus ilman masterpassia pyytää kirjoittamaan sen uudelleen.',
    secretEnvPromote: 'Tee salaiseksi yksi yllä kirjoitetuista muuttujista:',
    secretEnvAdd: 'Lisää salainen muuttuja',
    secretEnvName: 'Nimi',
    secretEnvValue: 'Arvo',
    secretEnvKept: 'säilytetty — jätä tyhjäksi, niin se pysyy ennallaan',
    secretEnvWithdrawWarning: 'Jos haluat lakata käsittelemästä salaisena muuttujaa, joka jo on salainen, kirjoita sille uusi arvo: pelkän merkinnän poistaminen olisi tapa LUKEA se, mikä ei tule ulos storesta. Muuttujan poistaminen sen sijaan poistaa sen kokonaan.',
    secretEnvChip: 'salainen',
    startNow: 'Käynnistä heti (muuten sovellus syntyy pysähdyksissä)',
    deletePersistentIntro: 'Tällä sovelluksella on pysyvää dataa — valitse, mitä sille tehdään:',
    deleteKeepData: 'Säilytä data (hakemistot jäävät storageilleen, orpoina)',
    deletePurgeData: 'Poista myös data',
    phase: 'Vaihe',
    phase_running: 'Käynnissä',
    phase_stopped: 'Pysäytetty',
    phase_error: 'Virhe',
    phase_unknown: 'Tuntematon',
    desiredState: 'Haluttu',
    wantedRunning: 'käynnissä',
    wantedStopped: 'pysäytetty',
    start: 'Käynnistä',
    stop: 'Pysäytä',
    restart: 'Käynnistä uudelleen',
    refreshImage: 'Päivitä image (omaksu uusi @current)',
    logs: 'Lokit',
    logsTitle: 'Lokit',
    logsEmpty: 'Ei kaapattua tulostetta.',
    shell: 'Shell',
    shellTitle: 'Shell',
    shellUnavailable: 'App ei ole käynnissä — shell tarvitsee elävän kontin. Sen lokit voi lukea missä tahansa tilassa.',
    shellConnect: 'Yhdistä',
    shellDisconnect: 'Katkaise',
    shellExited: 'Istunto päättyi poistumiskoodilla {code}.',
    shellEndedWithoutStatus: 'Istunto päättyi ilman poistumistilaa: {reason}',
    shellRevoked: 'Istunnon ticket ei ole enää voimassa — se vanheni, tai sen avannut kirjautuminen kumottiin.',
    shellHint: 'Napsauta mustaa ruutua ja kirjoita: näppäimet menevät konttiin. Ctrl+C ja nuolet toimivat; exit sulkee shellin.',
    shellStatus: {
      connecting: 'Yhdistetään…',
      connected: 'Yhdistetty',
      ended: 'Päättynyt'
    },
    deleteRunningError: '{name} on haluttu käynnissä olevaksi — pysäytä se ensin.',
    tabs: {
      general: 'Yleiset',
      image: 'Image',
      network: 'Verkko',
      storage: 'Storage',
      devices: 'Laitteet',
      observed: 'Havaittu'
    },
    attachment: 'Liitos',
    runningDigest: 'Käynnissä oleva digest',
    lastError: 'Viimeisin virhe',
    reportObservedAt: 'Workerin viimeisin report',
    desiredStateLock: 'Sitä hallitsevat toiminnot Käynnistä/Pysäytä — ei koskaan suora muokkaus.',
    ipEditDisabledHint: 'Muokattavissa vain staattisella jaolla.',
    derivedFromNetworkHint: 'Johdettu verkon ainoasta lähteestä — manuaalinen vain paljaalla bridgellä staattisella IP:llä.',
    ephemeralUnset: 'ei konfiguroitu',
    ephemeralMissing: 'Appien efemeeristä storagea ei ole konfiguroitu — sovelluksen luonti efemeerisin osin (root tai volyymit) hylätään, kunnes asetat sen.',
    ephemeralCurrent: 'Appien efemeerinen storage: {name}',
    ephemeralMissingCreate: 'Tällä sovelluksella on efemeerisiä osia, mutta Appien efemeeristä storagea ei ole asetettu — luonti hylätään. Aseta se ensin App-sivun bannerista.',
    setEphemeral: 'Aseta efemeerinen storage',
    changeEphemeral: 'Vaihda efemeerinen storage',
    setEphemeralTitle: 'Aseta Appien efemeerinen storage',
    changeEphemeralTitle: 'Vaihda Appien efemeerinen storage',
    ephemeralStorageHint: 'Klusterin OLETUS: dir-tyyppinen pool, jolla jokaisen sovelluksen efemeeriset rootit ja volyymit elävät, ellei sovellus ilmoita overridea. Vaihto ei tapahdu lennossa eikä käynnistä mitään uudelleen: voimassa kunkin sovelluksen seuraavasta startista — efemeerinen data ei siirry.',
    ephemeralPool: 'Storage-pool',
    ephemeralOverride: 'Efemeerinen storage (sovelluskohtainen override)',
    ephemeralOverrideInherit: 'Perii klusterin oletuksen',
    ephemeralOverrideInheritNamed: 'Perii klusterin oletuksen ({name})',
    ephemeralOverrideHint: 'Sovelluskohtainen pool efemeerisille rooteille ja volyymeille — jätä tyhjäksi periäksesi klusterin oletuksen. Vaihto ei tapahdu lennossa eikä käynnistä mitään uudelleen: voimassa seuraavasta startista (efemeerinen data syntyy tyhjänä uudelle poolille) ja vaatii oikeuden app.ephemeralStorage.set.',
    ephemeralOverrideTag: 'override',

    imageAnyBranch: 'Kaikki branchit',
    imageBranchHint: 'Rajaa imaget niihin, jotka tämä branch nimeää; ilman branchia näkyvät kaikki repositoryn imaget.',
    imageDigestHint: 'Sisältö: valitaan digest-taulukosta, joka kertoo sen alkuperän ja arkkitehtuurin. Sama branch tarjoaa yhden kutakin arkkitehtuuria kohti, eivätkä ne ole keskenään vaihdettavissa.',
    imageLockfile: 'Ratkaistu viite',
    imageNoImages: 'Tälle repositorylle ei ole imageja välimuistissa — lataa yksi OCI-imageista.',
    imageHeadNotCached: 'ei välimuistissa — haetaan käynnistyksessä',
    imageNoRegistries: 'Yhtään repositorya ei ole rekisteröity: rekisteröi yksi voidaksesi valita imagen.',
    imageChosenHint: 'Image valitaan muokkausikkunan valintaketjusta: viitettä ei koskaan kirjoiteta käsin.',
    registerRepositoryHint: 'Rekisteröinti ei lataa mitään: se tekee repositorysta seurattavan, jotta image voidaan valita poistumatta tästä ikkunasta.',
    registerRepositoryBranchHint: 'Valinnainen: ensimmäinen seurattava branch (esim. latest).',
    registerRepositoryElsewhere: 'Etsimääsi repositorya ei ole rekisteröity: rekisteröinti tehdään OCI-imaget-osiossa, ja sen tekee joku jolla on oikeus.'
  },
  cts: {
    createAction: 'Luo CT',
    createTitle: 'Luo container templatesta',
    createError: 'Containeria ei luotu',
    template: 'CT-template',
    noTemplates: 'Ei CT-templateja — tuo yksi kohdasta CT-templatet',
    resources: 'Resurssit',
    node: 'Solmu',
    phase: {
      defined: 'Ei koskaan käynnistetty',
      materializing: 'Materialisoitumassa',
      ready: 'Valmis',
      starting: 'Käynnistymässä',
      running: 'Käynnissä',
      stopping: 'Sammumassa',
      stopped: 'Sammutettu',
      deleting: 'Poistettavana',
      error: 'Virhetilassa'
    },
    actions: {
      start: 'Käynnistä',
      stop: 'Sammuta',
      restart: 'Käynnistä uudelleen',
      markTemplate: 'Ylennä CT-templateksi',
      error: 'Toiminto hylättiin'
    },
    markTemplate: {
      confirmTitle: "Ylennetäänkö '{name}' CT-templateksi?",
      confirmBody: 'Container poistuu tästä listasta ja siirtyy CT-templateihin, heti valmiina synnyttämään uusia CT:itä. Metadata pysyy muokattavana, ja voit palauttaa sen CT:ksi milloin tahansa.',
      confirm: 'Ylennä',
      moved: "'{name}' on nyt CT-template — löydät sen kohdasta CT-templatet."
    },
    stopCause: {
      api: 'TVirtin sammuttama',
      'ct-exit': 'Container päättyi itsestään',
      'host-reboot': 'Kuoli solmun uudelleenkäynnistyksen mukana',
      'start-failed': 'Käynnistys epäonnistui — taskin virhe kertoo, mitä puuttuu ja miten se korjataan'
    },

    console: 'Konsoli',
    consoleUnavailable: 'Container ei ole käynnissä — konsoli tarvitsee elävän containerin. Sen lokit sen sijaan luetaan missä tilassa tahansa.',
    consoleNoTemplate: 'Template ei käy koskaan, joten sillä ei ole konsolia: luo siitä CT ja avaa sen konsoli.',
    consoleConnect: 'Yhdistä',
    consoleDisconnect: 'Katkaise yhteys',
    consoleReconnect: 'Yhdistä uudelleen',
    consoleTakenBy: 'Toinen operaattori otti tämän konsolin ({user}). Yksi konsoli per container: uudelleen yhdistäminen ottaa sen takaisin.',
    consoleHint: 'Napsauta mustaa ruutua ja kirjoita: näppäimet menevät containeriin. Ctrl+C ja nuolinäppäimet toimivat.',
    consoleEndpointDown: 'Konsolin liityntäpistettä ei voi avata containeria palvelevalla nodella: {cause}',
    shell: 'Shell',
    shellTitle: 'Shell',
    shellUnavailable: 'Container ei ole käynnissä — shell tarvitsee elävän containerin. Sen logit voi lukea missä tahansa tilassa.',
    shellNoTemplate: 'Template ei koskaan käy, joten sillä ei ole shelliä: luo siitä CT ja avaa sen shell.',
    shellConnect: 'Yhdistä',
    shellDisconnect: 'Katkaise',
    shellExited: 'Istunto päättyi poistumiskoodilla {code}.',
    shellEndedWithoutStatus: 'Istunto päättyi ilman poistumistilaa: {reason}',
    shellRevoked: 'Istunnon ticket ei ole enää voimassa — se vanheni, tai sen avannut kirjautuminen kumottiin.',
    shellHint: 'Napsauta mustaa ruutua ja kirjoita: näppäimet menevät konttiin. Ctrl+C ja nuolet toimivat; exit sulkee shellin.',
    shellStatus: {
      connecting: 'Yhdistetään…',
      connected: 'Yhdistetty',
      ended: 'Päättynyt'
    },
    rootPassword: 'Root-salasana',
    rootPasswordHint: 'Kirjoitetaan kerran kopioituun rootfs:ään (hashina, ei näytetä enää). Jakeluiden imaget eivät sisällä root-salasanaa: ilman sitä shell on ainoa tie sisään.',
    sshKeys: 'Rootin julkiset SSH-avaimet',
    sshKeysHint: 'Yksi julkinen OpenSSH-avain riviä kohden, tiedostoon root/.ssh/authorized_keys.',
    consoleStatus: {
      connecting: 'Yhdistetään…',
      connected: 'Yhdistetty',
      reconnecting: 'Yhdistetään uudelleen…'
    },
    logs: 'Lokit',
    logsTitle: 'Lokit',
    logsEmpty: 'Ei kaapattua tulostetta.',
    logsSource: 'Mikä loki',
    logsSourceConsole: 'Containerin initin konsoli — miksi sisällä oleva palvelu ei käynnistynyt',
    logsSourceSupervisor: 'liblxc-valvoja — miksi container ei koskaan päässyt käyntiin',
    logsNeverStarted: 'Sitä ei ole koskaan käynnistetty, joten mitään ei ole vielä kirjattu — käynnistä se, ja lokit ovat siellä vaikka käynnistys epäonnistuisi.',
    logsNoTemplate: 'Template ei käy koskaan, joten se ei ole koskaan kirjannut mitään.',
    logsError: 'Lokeja ei saatu kaapattua',

    tabs: {
      general: 'Yleiset',
      hardware: 'Laitteisto',
      network: 'Verkko',
      provenance: 'Alkuperä'
    },
    templateFlag: 'CT-template',
    templateLock: 'Muuttuu vain toiminnoilla Ylennä / Palauta CT:ksi — ei koskaan suoralla muokkauksella.',
    sourceLock: 'Alkuperä, kirjattu syntymässä — ei koskaan uudelleenkirjoiteta; kuollut lähde jättää viittauksen paljaaksi.',
    storageLock: 'Kiinnitetty luonnissa — rootfs:n siirto on tulevan roundin asia.',
    startedAt: 'Käynnistetty',
    lastStop: 'Viimeisin sammutus',
    editNicsTitle: 'Muokkaa verkkoja',
    nicDisconnected: 'irrotettu'
  },
  ctTemplates: {
    title: 'CT-templatet',
    importAction: 'Tuo katalogista',
    importTitle: 'Tuo CT-template katalogista',
    importSubmit: 'Tuo',
    importError: 'Import hylättiin',
    importHint: 'Materialisointi kopioi rootfs:n valitulle storagelle — katalogin tiedosto säilyy koskemattomana. Lisätäksesi uusia tiedostoja lataa ne ensin katalogiin.',
    sourceFile: 'CT-template-tiedosto',
    sourceFileHint: 'Valitun katalogin ct-rootfs-tiedostot, vain valmiit',
    noFiles: 'Ei valmiita ct-rootfs-tiedostoja tässä katalogissa — lataa yksi katalogin sivulta',
    source: 'Lähdetiedosto',
    rootfsStorage: 'Rootfs:n storage',
    rootfsStorageHint: "Missä purettu rootfs-puu elää — storage, jossa on tiedostojärjestelmä ja vapaata tilaa puretun koon verran plus noin 1 GiB pelivaraa (muuten import epäonnistuu).",
    resources: 'Resurssit',
    cores: 'vCPU',
    memoryMiB: 'Muisti (MiB)',
    cpuLimit: 'CPU-raja',
    cpuLimitHint: 'Host-core-ekvivalentteja (esim. 1.5); tyhjä = ei kattoa',
    cpuUncapped: 'ei kattoa',
    cpuWeight: 'CPU-paino',
    hostname: 'Hostname',
    hostnameHint: 'Tyhjä = CT:n nimi',
    nameservers: 'DNS-nameserverit',
    dnsHint: 'Pilkulla eroteltuina; tyhjä = perii hostin omat',
    searchDomains: 'DNS-hakuverkkotunnukset',
    dnsInherited: 'Peritty hostilta',
    networks: 'Verkot',
    nicSlot: 'NIC-slot',
    phase: {
      materializing: 'Materialisoitumassa',
      ready: 'Valmis',
      deleting: 'Poistettavana',
      error: 'Virhe'
    },
    exportAction: 'Vie katalogiin',
    exportTitle: 'Vie katalogiin',
    exportSubmit: 'Vie',
    exportError: 'Export hylättiin',
    exportHint: 'Paketoi materialisoidun rootfs:n UUDEKSI ct-rootfs-tiedostoksi valittuun katalogiin — template säilyy koskemattomana.',
    exportName: 'Tiedoston nimi',
    exportNameHint: 'Tyhjä = <template>-export-<n>',
    markCt: {
      action: 'Palauta CT:ksi',
      confirmTitle: "Palautetaanko '{name}' CT:ksi?",
      confirmBody: 'Template poistuu tästä listasta ja palaa CT-listaan, taas käynnistettävissä. Ennen kuin ylennät sen uudelleen, siitä ei voi luoda CT:itä.',
      confirm: 'Palauta CT:ksi',
      moved: "'{name}' on taas CT — löydät sen CT-listasta."
    }
  },
  oci: {
    registriesTitle: 'OCI-registryt',
    imagesTitle: 'OCI-imaget',
    provider: 'Provider',
    providerDockerhub: 'Docker Hub',
    providerGhcr: 'GHCR',
    providerEcr: 'Amazon ECR',
    providerQuay: 'Red Hat Quay',
    providerGeneric: 'Geneerinen',
    providerImmutableHint: 'Provider on muuttumaton luonnin jälkeen — eri provider on uusi registry.',
    url: 'URL',
    urlHintPreset: 'Esitäytetty providerin mukaan — ylikirjoita vain mirroreille.',
    urlHintRequired: 'Pakollinen geneerisille registryille: perus-URL (https://).',
    urlHintEcr: 'Pakollinen: ECR-endpointit ovat per-tili/per-alue — presetiä ei ole.',
    credential: 'Tunnukset',
    credentialNone: 'Anonyymi pääsy',
    credentialHint: 'Keystoren käyttäjä-ja-salasana-merkintä; workerit ratkaisevat sen käyttöhetkellä — ei koskaan per-solmu auth-tiedostoja.',
    nameHint: 'Host-tyylinen nimi (docker.io, registry.intra); uniikki per scope, muuttumaton',
    addRegistry: 'Lisää registry',
    addRegistryTitle: 'Lisää OCI-registry',
    verify: 'Tarkista',
    verifyState: 'Tarkistus',
    verified: 'Tarkistettu',
    verifyFailed: 'Epäonnistui',
    neverVerified: 'Ei koskaan tarkistettu',
    registryInUseError: "'{name}' sisältää yhä rekisteröityjä repositoryja — poista ne ensin.",
    repositories: 'Repositoryt',
    repositoriesHint: 'Rekisteröinti havainnoi branchit (OCI-tagit) — mitään ei ladata. Refresh ratkaisee jokaisen havainnoidun branchin ja ylläpitää reflogia.',
    noRepositories: 'Ei rekisteröityjä repositoryja tällä registryllä.',
    registerRepository: 'Rekisteröi repository',
    repoPath: 'Polku',
    repoPathHint: "Repositoryn polku registryllä, esim. 'example' tai 'library/nginx'",
    branches: 'Branchit',
    branchesHint: 'Havainnoidut branchit (OCI-tagit), pilkulla eroteltuina — esim. 1.1.0, 1.1.1',
    branch: 'Branch',
    branchPullHint: 'Ratkaistaan NYT: pull lataa digestin, johon branch osoittaa tänään.',
    refresh: 'Päivitä',
    deleteRepository: 'Poista repository',
    reflogCount: '{n} aiempaa',
    noResolutions: 'Ei koskaan päivitetty — ei havaittuja ratkaisuja.',
    refreshFailed: 'Viimeisin päivitys epäonnistui ({when})',
    loadError: 'Repositoryjen lataus ei onnistunut.',
    reference: 'Viittaus',
    digest: 'Digest',
    digestHint: 'sha256:… — täsmälleen tämä image, ilman branchia (detached)',
    size: 'Koko',
    nodes: 'Solmut',
    detached: 'detached',
    detachedHint: 'Ladattu digestillä, ilman branchia — drift-tarkistus ei koske sitä.',
    pulledAt: 'Ladattu',
    pull: 'Pull',
    pullTitle: 'Imagen pull',
    pullHint: 'Esilämmitystä, ei koskaan edellytys: pull branchilla ratkaisee NYT ja lataa JUURI SEN digestin; pull digestillä on detached.',
    pullError: 'Pull hylättiin',
    pullMode: 'Pull-tapa',
    pullModeBranch: 'Branch (ratkaise nyt)',
    pullModeDigest: 'Digest (detached)',
    pullModeBranchHint: 'Rehellinen oletus: kuten apt install — myöhemmin uudelleen ajettuna voi antaa eri imagen.',
    pullModeDigestHint: 'Täsmällinen digest — toistettavuus ja rollback; luopuu drift-tarkistuksesta.',
    importFromRegistry: 'Tuo registrystä',
    importFromCatalog: 'Tuo katalogista',
    importCatalogTitle: 'Tuo OCI-image katalogista',
    importCatalogHint: 'Air-gapped-tie: valmis oci-image-arkisto (tar/tar.gz — docker-archive tai oci-archive) materialisoidaan image-storeen viittauksella catalog/<katalogi>/<tiedosto>@<digest>; sovellukset käyttävät sitä kuin mitä tahansa muuta imagea. Arkistot ladataan katalogeihin — tämä osio vain tuo.',
    importCatalogFile: 'Arkisto',
    importCatalogFileHint: 'Valitun katalogin valmiit oci-image-tiedostot.',
    importCatalogNoFiles: 'Ei valmiita oci-image-arkistoja tässä katalogissa — lataa yksi katalogin tietosivulta.',
    importCatalogError: 'Import hylättiin',
    registry: 'Registry',
    repository: 'Repository',
    cacheMissing: 'Klusterin OCI-cachea ei ole konfiguroitu — pullit hylätään, kunnes asetat storage-poolin.',
    setCache: 'Aseta cache',
    setCacheTitle: 'Konfiguroi OCI-cache',
    setCacheHint: 'Klusteritason OLETUS-pool, jolla ladattujen imagejen blobit asuvat — scope voi tehdä overriden omalla poolillaan (Scope-sivu). Vaihto ei tapahdu lennossa eikä käynnistä mitään uudelleen, eikä siirrä blobeja: ne ilmestyvät laiskasti seuraavassa startissa/käytössä.',
    cachePool: 'Storage-pool',
    changeCache: 'Vaihda cache',
    changeCacheTitle: 'Vaihda OCI-cachen pool',
    cacheCurrent: 'Klusterin OCI-cache (oletus): {name}',
    sectionOverview: 'Yleiskuva',
    sectionRepositories: 'Repositoryt',
    sectionExplore: 'Selaa',
    exploreHint: 'Live-etähaku registryltä — Docker Hub täytenä (kuvaus, lataukset, tähdet), muut providerit best-effort. Valitse tulos lukeaksesi koko kuvauksen ja selataksesi sen etätageja; tagista voit lisätä viittauksen TVirt-repositoryyn.',
    exploreSearch: 'Hae',
    exploreUnsupported: 'Tämä provider ei tue hakua.',
    exploreNoResult: 'Ei vastaavia repositoryja.',
    exploreNoTags: 'Ei vastaavia tageja tällä repositoryllä.',
    exploreOfficial: 'Virallinen',
    explorePulls: 'Lataukset',
    exploreStars: 'Tähdet',
    exploreUpdated: 'Päivitetty {when}',
    exploreLoadMore: 'Lataa lisää',
    exploreSelectHint: 'Valitse tulos: koko kuvaus ja etätagit latautuvat tähän.',
    exploreNoDescription: 'Ei kuvausta saatavilla tältä providerilta.',
    exploreTagsTitle: 'Etätagit',
    exploreTagFilter: 'Hae tageja',
    exploreAddToRepo: 'Lisää repositoryyn',
    exploreAdded: '{path}:{tag} on nyt seurannassa — katso Repositoryt-osio.',
    addBranch: 'Lisää branch',
    purgeRequiredTitle: "Poistetaanko '{name}' ja sen imaget?",
    purgeRequiredBody: 'Yksikään app ei käytä tätä repositorya, mutta ladattuja imageja on yhä: poisto vie myös niiden tietueet, ja välimuistin blobit siirtyvät garbage collectionille.',
    purgeConfirm: 'Poista myös imaget',
    providerSelectHint: 'Valitse registryn tyyppi: kortti kertoo esiasetuksen ja käytön.',
    providerDesc: {
      dockerhub: 'Julkinen Docker-registry: URL esitäytetty, täysi haku kuvauksineen ja laskureineen.',
      ghcr: 'GitHub Container Registry: URL esitäytetty; tilit käyttävät personal access tokenia.',
      ecr: 'Amazon Elastic Container Registry: endpointit ovat tili- ja aluekohtaisia — URL on annettava.',
      quay: 'Red Hat Quay -registry: URL esitäytetty.',
      generic: 'Self-hosted registry (Harbor, registry:2, …): https://-URL on pakollinen.'
    },
    layerCount: 'Layer',
    verifiedAt: 'Viimeisin tarkistus',
    verifyOk: 'Tulos',
    verifyMessage: 'Tarkistusviesti',

    // Malli #348/R39: image ON digest — sisältö — ja registry, repository ja branch ovat NIMET, jotka tavoittavat sen.
    head: 'Head',
    heads: 'Headit arkkitehtuureittain',
    listDigest: 'Listan digest',
    neverResolved: 'Ei koskaan ratkaistu',
    totalSize: 'Kokonaiskoko',
    reflogTitle: 'Ratkaisujen historia',
    usedBy: 'Käyttää',
    usageLockfile: 'lockfile',
    usageRunning: 'käynnissä',
    evictable: 'poistettavissa',
    evict: 'Poista välimuistista',
    evictHeadTitle: 'Poistetaanko {digest}?',
    evictHeadBody: 'Se on vähintään yhden kokoajan nykyinen ratkaisu: poistaminen on laillista — kyse on vain välimuistista, etäbranch tarjoaa sen yhä — mutta se ei saa tapahtua vahingossa. Blob on YKSI: poisto tyhjentää kaikki sitä jakavat kokoajat.',
    evictConfirm: 'Poista silti',

    arch: 'Arkkitehtuuri',
    names: 'Nimet',
    noNames: 'ei nimeä',
    views: 'Näkymät',
    lastView: 'viimeinen näkymä',
    evictLastViewTitle: 'Poistetaanko viimeinen viittaus digestiin {digest}?',
    evictLastViewBody: 'Tämä on sisällön viimeinen näkymä: kun se poistetaan, image lakkaa olemasta TVirtissä ja tavut ({size}) vapautuvat. Tämä on mallin docker image rm — ei sivuvaikutus vaan itse toimenpide.',
    branchesTabHint: 'Tämän repositoryn seuratut branchit: kustakin tämän päivän headit — yksi kutakin arkkitehtuuria kohti — päivitysten aikajana ja kuinka moni sen nimeämistä imageista on välimuistissa. Päivitys on repositoryn «git fetch»: se ratkaisee kaikki branchit kerralla.',
    noBranches: 'Tässä repositoryssa ei seurata yhtään branchia.',
    stopObserving: 'Lopeta branchin seuraaminen',
    pullBranch: 'Hae branchin head välimuistiin (refresh selvittää, tämä lataa)',
    pullDigest: 'Hae tämä digest välimuistiin',
    imageCount: 'Imaget',
    deleteBranchPurgeTitle: 'Jätetäänkö kohteen {name} imaget ilman nimeä?',
    deleteBranchPurgeBody: 'Yksikään sovellus ei nimeä tätä branchia, mutta osa imageista tavoitetaan vain sen kautta: poistettaessa ne jäävät välimuistiin nimettöminä, listattuina repositoryn imageihin ja käsin poistettavina.',
    deleteBranchPurgeConfirm: 'Poista ja jätä imaget nimettömiksi',
    imagesTabHint: 'Tämän repositoryn imaget — sisällöt eli digestit — näkyvät myös ilman branchin valintaa. Image on klusterikohtaisesti yksilöllinen: sen tavoittavia nimiä voi olla useita.',
    noImages: 'Yhtään tämän repositoryn imagea ei ole materialisoitu välimuistiin.',
    deleteRepositoryTitle: 'Poistetaanko {name}?',
    deleteRepositoryBody: 'Repository ja sen branchit katoavat aikajanoineen. Imaget jäävät välimuistiin: ne menettävät vain tämän nimen. Repositorya, jonka sovellus nimeää, ei voi poistaa.',
    provenanceCatalog: 'luettelo',
    refreshedAt: 'Päivitetty',
    neverRefreshed: 'Ei koskaan päivitetty',
    sectionBranches: 'Branchit',
    sectionImages: 'Imaget',
    repositoriesGovernedElsewhere: 'Täällä repositoryja vain katsellaan: niiden rekisteröinti, päivitys, branchien seuraaminen ja imageiden poisto tehdään OCI-imaget-osiossa.',
    gotoImages: 'Siirry OCI-imageihin'
  },

  // Pod nativi (P1): the Pod list — the template's census of instances, the
  // whole-Pod lifecycle, the scale and the delete.
  pods: {
    title: 'Podit',
    containers: 'Kontit',
    instances: 'Instanssit',
    instancesTooltip: '{running} käynnissä, {error} virhetilassa',
    placement: 'Sijoittelu',
    spread: 'hajautus',
    ha: 'HA',
    templateRevision: 'revisio',
    deleting: 'Poistetaan',
    empty: 'Ei podeja — luo sovellus (yksi kontti) tai pod CLI:stä (create-pod).',
    openInstances: 'Avaa instanssit',
    rollingRestart: 'Vaiheittainen uudelleenkäynnistys',
    scale: 'Skaalaa',
    scaleTitle: 'Skaalaa {name}',
    scaleHint: 'Instanssien määrä (0–64): ylöspäin täytetään alin vapaa järjestysnumero, alaspäin poistetaan korkein ja sen pysyvät tiedot säilyvät.',
    scaleError: 'Skaalaus epäonnistui',
    replicas: 'Replikat',
    deleteRunningError: '{name} on käynnissä — pysäytä se ensin.',
    deleteInstancesIntro: 'Kaikki {count} instanssia poistetaan.',
    stateRunning: 'Käynnissä',
    stateStopped: 'Pysäytetty',
    editor: {
      createTitle: 'Luo Pod',
      create: 'Luo Pod',
      editTitle: 'Muokkaa Podia',
      nameHint: 'DNS-1123, enintään 58 merkkiä — instanssit nimetään <nimi>-<indeksi>; muuttumaton luonnin jälkeen.',
      restartPolicy: 'Uudelleenkäynnistyskäytäntö',
      restartPolicyHint_always: 'Solmu käynnistää uudelleen jokaisen päättyneen kontin eksponentiaalisella odotuksella (10 s → 5 min).',
      restartPolicyHint_onFailure: 'Vain nollasta poikkeavalla koodilla päättynyt kontti käynnistetään uudelleen; paluuarvo 0 jää lepoon.',
      restartPolicyHint_never: 'Päättynyt kontti jätetään sellaisekseen — instanssi päättyy tilaan succeeded tai failed.',
      grace: 'Armonaika (s)',
      graceHint: 'Pysäytyksen SIGTERM → SIGKILL -raja.',
      hostname: 'Isäntänimi',
      hostnameHint: 'Tyhjä = instanssin nimi.',
      hostnameDefault: 'instanssin nimi',
      sharePid: 'Jaa PID-nimiavaruus konttien kesken',
      containersIntro: 'Init-kontit ajetaan loppuun järjestyksessä ennen konttien käynnistymistä; kontit jakavat instanssin verkon (yksi IP, localhost keskenään).',
      initContainers: 'Init-kontit',
      initAdd: 'Lisää init-kontti',
      initHint: 'Jokaisen on päätyttävä koodilla 0; epäonnistuminen vie instanssin virhetilaan ja solmu yrittää uudelleen odotuksella.',
      containerAdd: 'Lisää kontti',
      atLeastOne: 'Pod tarvitsee vähintään yhden kontin.',
      duplicateNames: 'Konttien nimien on oltava yksilöllisiä Podissa (init-kontit mukaan lukien).',
      containerName: 'Kontin nimi',
      containerInvalid: 'Tämä kontti on puutteellinen: nimi (DNS-1123), levykuva, liitokset ilmoitettuihin taltioihin, numeeriset rajat ja koetin.',
      command: 'Komento',
      commandHint: 'Korvaa levykuvan entrypointin — yksi argumentti riviä kohden, ei koskaan komentotulkin merkkijono.',
      args: 'Argumentit',
      argsHint: 'Yksi riviä kohden (levykuvan CMD, jos tyhjä).',
      mounts: 'Liitokset',
      mountAdd: 'Lisää liitos',
      mountNoVolumes: 'Ilmoita ensin taltio Tallennus-välilehdellä.',
      readOnly: 'vain luku',
      resources: 'Rajat',
      cpus: 'CPU',
      cpusHint: 'podman --cpus (esim. 1.5)',
      memory: 'Muisti (MiB)',
      memoryHint: 'podman --memory',
      health: 'Elossaolokoetin',
      healthCmd: 'Koettimen komento',
      healthCmdHint: 'Solmu ajaa sen kontin sisällä jokaisella valvontakierroksella — yksi argumentti riviä kohden; paluuarvo 0 = terve.',
      healthTimeout: 'Aikakatkaisu (s)',
      healthRetries: 'Yritykset',
      healthRetriesHint: 'Peräkkäiset epäonnistumiset ennen kuin solmu käynnistää kontin uudelleen.',
      ips: 'Staattiset osoitteet',
      ipsHint: 'Yksi instanssia kohden, järjestysnumeron mukaan — listan yli skaalaus hylätään.',
      instance: 'instanssi',
      volumesHint: 'Taltiot ovat Podin; liitospolku on kunkin kontin (Kontit-välilehti).',
      spread: 'Hajautus',
      spreadHint_preferred: 'Instanssit eri solmuille, kun mahdollista.',
      spreadHint_required: 'Instanssit eri solmuille, muuten skaalaus hylätään.',
      spreadHint_none: 'Vain päättäjä.',
      ha: 'Korkea käytettävyys (opt-in)',
      haHint: 'Jokainen pysyvä osa jaetulla storagella; jos solmu kuolee, HA-decider luo instanssit uudelleen toiselle jäsenelle (automaattinen failover, kuten HA-VM:illä).',
      yes: 'kyllä',
      no: 'ei'
    },
    detail: {
      container: 'Kontti',
      actions: 'Toiminnot',
      ready: 'Valmis',
      notReady: 'Ei valmis',
      restarts: 'Uudelleenkäynnistykset',
      lastRestartAt: 'Viimeisin uudelleenkäynnistys:',
      backoffUntil: 'Uusi yritys klo',
      stateAbsent: 'puuttuu',
      stateRunning: 'käynnissä',
      stateTerminated: 'päättynyt',
      stateWaiting: 'odottaa',
      init: 'init',
      noInstances: 'Ei instansseja (replikoita 0).',
      ha: 'HA',
      haHint: 'Automaattinen failover: jos solmu kuolee, HA-decider luo instanssin uudelleen toiselle jäsenelle (jokainen pysyvä osa jaetulla storagella).',
      authority: 'Authority (solmu)',
      homeless: 'ei authoritya',
      homelessHint: 'Checkpoint-palautus jättää authorityn pois (#380): mikään solmu ei palvele sitä, ennen kuin skaalaat Podin (vaikka samaan replikamäärään).',
      restartContainer: 'Käynnistä uudelleen vain tämä kontti (pod pysyy pystyssä)',
      divergingHint: 'Tämän instanssin haluttu tila poikkeaa Podin oletuksesta (PD-P19).',
      revisionLag: 'revisio {applied} sovellettu, nykyinen {current}',
      updatedInstances: '{updated}/{desired} instanssia tällä revisiolla'
    }
  }
}
